export enum DisputesHistoryDialogFieldNamesEnum {
  UPDATED_DATE = 'statusDateTime',
  DISPUTE_STATUS = 'statusCd',
  UPDATED_BY = 'employeeName',
}
